(function($) {

    function App() {

        var
            _app = this,
            win = $(window),
            body = $('body'),
            screen = 'xs',
            bp = {
                sm : 768,
                md : 992,
                lg : 1200
            };

        this.getScreenType = function() {
            var t,
                w = win.width(),
                h = win.height();

            if (w < bp.sm) {
                t = 'xs';
            }
            else if (w < bp.md) {
                t = 'sm';
            }
            else if (w < bp.lg) {
                t = 'md';
            }
            else if (bp.lg <= w) {
                t = 'lg';
            }
            _app.screen = t;
            return t;
        };
        this.handleScreenResize = function() {
            win.resize(function(){
                _app.getScreenType();
            }).resize();
        };
        this.handleHeaderSlider = function() {

            if ($("#header-slider").length === 0) return;

            $('.slide-wrapper').css('height', win.height());

            var headerSlider = $('#header-slider'),
                arrow = $('.icon-scroll');

            if (headerSlider.length > 0) {
                headerSlider.slick({
                    arrows: false,
                    dots: true,
                    dotsClass: 'dots',
                    autoplay: false,
                    autoplaySpeed: 5000,
                });
            }

            arrow.on('click', function() {
                $('html, body').animate({
                    scrollTop: $('#main').offset().top
                }, 500);
            });

        };
        this.handleImageSlider = function() {

            var imageSlider = $('#image-slider');

            if (imageSlider.length > 0) {
                imageSlider.slick({
                    arrows: true,
                    prevArrow: '<a href="javascript:;" class="arrow arrow-prev"><i class="glyphicon glyphicon-arrow-left"></i></a>',
                    nextArrow: '<a href="javascript:;" class="arrow arrow-next"><i class="glyphicon glyphicon-arrow-right"></i></a>',
                    dots: false,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                });
            }

        };
        this.handleHamburger = function() {

            var hamburger = $('.hamburger');

            hamburger.on('click', function() {
                hamburger.toggleClass('is-active');
                body.toggleClass('mobile-menu-is-active');
            });

        };
        this.wrapEmbeds = function() {
            $('#main').find('iframe').not('.nowrap').addClass('embed-responsive-item').wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
        };
        this.init = function() {

            _app.handleScreenResize();
            _app.handleHeaderSlider();
            _app.handleImageSlider();
            _app.handleHamburger();
            _app.wrapEmbeds();

            $('.open-booknow').magnificPopup({
                type:'inline',
                midClick: true
            });

        };

    }

    jQuery(function() {

        var app = new App();
        app.init();

    });

})( jQuery );
